import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled/text';

import { asFormDateField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { formatDateValueForView } from '../../../../../../../../common/utils';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewDateInput = ({ fieldId }: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formDateField = asFormDateField(formField);
	const intl = useIntl();

	if (formDateField === undefined) {
		return <></>;
	}

	return (
		<Text testId={`field-input-date-view-${fieldId}`}>
			{formatDateValueForView(formDateField.value?.date, intl.locale)}
		</Text>
	);
};
